import { create } from 'zustand';

export type CIConfigExpertAvailability = 'unavailable' | 'enabled' | 'disabled-by-project' | 'disabled-by-workspace';

type WorkflowEditorPageState = {
  ciConfigSlug: string | undefined;
  projectId: string | undefined;
  ciConfigExpertAvailability: CIConfigExpertAvailability;
  canChangeProjectSettings: boolean;
  conversationId: string | undefined;
  hasBeenOpened: boolean;
  markAsViewed: () => void;
  reset: () => void;
};

const initialState = {
  ciConfigSlug: undefined,
  projectId: undefined,
  ciConfigExpertAvailability: 'unavailable' as CIConfigExpertAvailability,
  canChangeProjectSettings: false,
  conversationId: undefined,
  hasBeenOpened: false,
};

const useWorkflowEditorPageStore = create<WorkflowEditorPageState>((set) => ({
  ...initialState,
  markAsViewed: () => set({ hasBeenOpened: true }),
  reset: () => set(initialState),
}));

export default useWorkflowEditorPageStore;
